import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { handleForgotPasswordResetCode } from '../../common/auth/AuthService';
import {
  Stack,
  TextField,
  Typography,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
const validationSchema = Yup.object().shape({
  username: Yup.string().email('Invalid Email').required('Required'),
});

export default function RequestResetForm(props) {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <Formik
      initialValues={{ username: '' }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        handleForgotPasswordResetCode(values.username)
          .then(() => {
            props.setUsername(values.username);
            props.successAction();
          })
          .catch((err) => {
            console.error(err);
            setErrorMessage(err.message);
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => (
        <>
          <Form>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='center'
              spacing={2}
            >
              <TextField
                name='username'
                type='email'
                label='Email'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.username}
                placeholder='Email'
                variant='standard'
                error={errors.username && touched.username}
                helperText={touched.username && errors.username}
                sx={{ m: 1, width: '20vw', minWidth: '35ch' }}
                inputProps={{ maxLength: 256 }}
              />

              {errorMessage && (
                <Typography sx={{ color: 'error.main' }}>
                  {errorMessage}
                </Typography>
              )}
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  sx={{ marginTop: 1 }}
                  type={'submit'}
                  disabled={isSubmitting}
                  variant='contained'
                >
                  Request Code
                </Button>
                {isSubmitting && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: 'secondary.main',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            </Stack>
          </Form>
        </>
      )}
    </Formik>
  );
}
